const TaskInfoTestIdsScope = {
  TASK_INFO_FORM: 'task-info-form',
};

export const TaskInfoTestIds = {
  // ReasonForm
  REASON_FORM_USER_NOTE_INPUT: 'reason-form.user-note-input',

  // TaskInfo
  TASK_INFO_FORM_EXPECTED_DATE: `${TaskInfoTestIdsScope.TASK_INFO_FORM}.expected-date`,
  TASK_INFO_FORM_IS_ORDERED_CHECKBOX: `${TaskInfoTestIdsScope.TASK_INFO_FORM}.is-ordered-checkbox`,
  TASK_INFO_FORM_LAST_MODIFIED_INPUT: `${TaskInfoTestIdsScope.TASK_INFO_FORM}.last-modified-input`,
  TASK_INFO_FORM_ORDERED_DATE: `${TaskInfoTestIdsScope.TASK_INFO_FORM}.ordered-date`,
  TASK_INFO_FORM_SUBMITTED_TEXT_INPUT: `${TaskInfoTestIdsScope.TASK_INFO_FORM}.submitted-text-input`,
  TASK_INFO_FORM_APPROVE_BUTTON: `${TaskInfoTestIdsScope.TASK_INFO_FORM}.approve-button`,
  TASK_INFO_FORM_BUSINESS_DAYS_TURNAROUND_INPUT: `${TaskInfoTestIdsScope.TASK_INFO_FORM}.business-days-turnaround-input`,
  TASK_INFO_FORM_CANCEL_BUTTON: `${TaskInfoTestIdsScope.TASK_INFO_FORM}.cancel-button`,
  TASK_INFO_FORM_DESCRIPTION_INPUT: `${TaskInfoTestIdsScope.TASK_INFO_FORM}.description-input`,
  TASK_INFO_FORM_NAME_INPUT: `${TaskInfoTestIdsScope.TASK_INFO_FORM}.name-input`,
  TASK_INFO_FORM_REJECT_BUTTON: `${TaskInfoTestIdsScope.TASK_INFO_FORM}.reject-button`,
  TASK_INFO_FORM_RESTORE_BUTTON: `${TaskInfoTestIdsScope.TASK_INFO_FORM}.restore-button`,
  TASK_INFO_FORM_STATUS_SELECT: `${TaskInfoTestIdsScope.TASK_INFO_FORM}.status-select`,
  TASK_INFO_FORM_SUBMIT_BUTTON: `${TaskInfoTestIdsScope.TASK_INFO_FORM}.submit-button`,
  TASK_INFO_FORM_TASK_ACTION_BUTTON: `${TaskInfoTestIdsScope.TASK_INFO_FORM}.task-action-button`,
  TASK_INFO_FORM_UPDATE_BUTTON: `${TaskInfoTestIdsScope.TASK_INFO_FORM}.update-button`,
  TASK_INFO_FORM_USER_NOTE_INPUT: `${TaskInfoTestIdsScope.TASK_INFO_FORM}.user-note-input`,

  // Dynamic
  getOpenDocumentButtonId: id =>
    `${TaskInfoTestIdsScope.TASK_INFO_FORM}.open-document-button-${id}`,
};
